<div class="app stokker-shell">
  <app-header></app-header>
  <div class="main-content">
    <app-left-menu *ngIf="isUserAuthenticated()"></app-left-menu>
    <main class="shell-main" [@routeAnimation]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
    </main>
  </div>
  <app-pwa-banner *ngIf="isUserAuthenticated()"></app-pwa-banner>
  <app-mobile-tab-bar *ngIf="isUserAuthenticated()"></app-mobile-tab-bar>
  <app-notification></app-notification>
  <div class="app-version-badge">{{ imageVersionLabel }}</div>
</div>
